export function parseInspectionResultsDeepLink(search) {
  const params = new URLSearchParams(search || '');
  const partId = Number(params.get('partId'));
  if (!Number.isFinite(partId) || partId <= 0) {
    return null;
  }

  const resultIdRaw = params.get('resultId');
  const resultId = resultIdRaw ? Number(resultIdRaw) : null;
  const tab = (params.get('tab') || 'aql').toLowerCase();
  const workTicket = (params.get('workTicket') || '').trim();

  return {
    partId,
    resultId: Number.isFinite(resultId) && resultId > 0 ? resultId : null,
    tab: tab === 'release' || tab === 'qc' ? 'release' : 'aql',
    workTicket,
  };
}

export function findFocusedInspectionResultIndex(results, focusedResultId, focusedWorkTicket) {
  if (!Array.isArray(results) || results.length === 0) {
    return -1;
  }

  if (focusedResultId != null && focusedResultId !== '') {
    const byId = results.findIndex(item => String(item?.id) === String(focusedResultId));
    if (byId >= 0) {
      return byId;
    }
  }

  const ticket = String(focusedWorkTicket || '').trim();
  if (!ticket) {
    return -1;
  }

  return results.findIndex(
    item => String(item?.workTicketNumber || '').trim() === ticket,
  );
}

export const findFocusedAqlIndex = findFocusedInspectionResultIndex;
